import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@parkschannel/ui";
import React from "react";
import { CTAList } from "../../../CallToAction";
import { useAuth } from "../../../Auth/AuthContext";
export const BecomeCreatorCTASection = ()=>{
    const { useSession  } = useAuth();
    const { data: session  } = useSession();
    return /*#__PURE__*/ _jsx("div", {
        className: "bg-white py-10 pl-4 md:pl-[30px] lg:px-10 lg:py-[80px]",
        children: /*#__PURE__*/ _jsx("div", {
            className: "w-full max-w-6xl mx-auto ",
            children: /*#__PURE__*/ _jsxs("section", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h2",
                        className: "pr-4 text-neutral-900 mb-6 md:pr-[30px] lg:hidden",
                        children: "How to start?"
                    }),
                    /*#__PURE__*/ _jsx(CTAList, {
                        data: [
                            {
                                id: 1,
                                title: "Explore our map to get inspired - then find your park.",
                                text: "Travel with our map, see what other people submit and get inspired to travel.",
                                linkText: "Explore map",
                                linkHref: "/explore-parks",
                                img: "/media/road-phone.jpg"
                            },
                            {
                                id: 2,
                                title: "Sign up and read our guidelines",
                                text: "We carefully curate the videos on Parks Channel. Learn what works and what doesn't.",
                                linkText: "Read guidelines",
                                linkHref: "/utilities/guidelines",
                                img: "/media/mountain-camera.jpg"
                            },
                            {
                                id: 3,
                                title: "Share videos",
                                text: "Select videos and share with the community. Inspire others and become an influencer!.",
                                linkText: "Upload a video",
                                linkHref: !session ? "/utilities/guidelines/" : "/videos/new",
                                img: "/media/mountain-man-photography.jpg"
                            }
                        ]
                    })
                ]
            })
        })
    });
};
